import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './empmodal.css';
import { CloseOutlined } from "@ant-design/icons";
import SearchComponent from '../searchcomponent/SearchComponent';
import GetImage from '../getimage/Getimage';
const Empmodal = ({ show, handleclose, data = [], onChange,selecttext,selectedValue }) => {
 console.log(data,"dataaaaaaaaaa")
  const [showSearch, setShowSearch] = useState(true);
  const [search, setSearch] = useState('');
  const [filteredManagers, setFilteredManagers] = useState(data);
  const [normalizedData, setNormalizedData] = useState([]);
const normalizeDropdownData = () =>
  Array.isArray(data) && data.length > 0
    ? data.map((item) => {
        if (item?.value !== undefined && item?.label !== undefined) {
          return item;
        }

        return {
          value: item.empid ?? item.value ?? 0,
          label:
            item.name ??
            `${item.firstname ?? ""} ${item.lastname ?? ""}`.trim() ??
            item.label ??
            "",
        };
      })
    : [];

useEffect(() => {
  if(data.length === 0 ) return;
  const normalized = normalizeDropdownData();
  setNormalizedData(normalized);
  setFilteredManagers(normalized);
}, [data]);


 
const handleCloseSearch = () => {
   setShowSearch(false);
    setSearch('');
    setFilteredManagers(normalizedData);
};

const handleSearch = (val) => {
  const value = val.toLowerCase();
  setSearch(val);

  const filtered = value
    ? normalizedData.filter((m) =>
        m.label.toLowerCase().includes(value)
      )
    : normalizedData;

  setFilteredManagers(filtered);
};

  const handleEmpClick = (manager) => {
    console.log(manager,"gjhfsdksjrvfnekjdmbhvgnjfrkc")
    onChange && onChange(manager.value, manager.label);
    handleclose();
    handleCloseSearch()
  };

  return (
    <Modal className='allmodalblur' show={show} onHide={handleclose} centered >
      <Modal.Header style={{padding:"30px 10px" , height:"50px" , backgroundColor:"rgb(221,221,221,0.23)"}}>
  <div className="d-flex justify-content-between align-items-center w-100">
 
    <div style={{ flex: 1, fontWeight: '500', fontSize: '18px', color:"#29b6f6" }}>
     {selecttext}
    </div>
    <div className={`search-header}`} >
                 <SearchComponent  searchvalue={search} storeSearch={(data)=>{handleSearch(data)}}/>
    </div>


    <CloseOutlined className='closemodal' style={{paddingLeft:"20px"}} onClick={()=>{
handleclose()
handleCloseSearch()
        }}/>

  </div>
</Modal.Header>

   <Modal.Body style={{ padding: '0px 0px' }}>
  <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
    {filteredManagers.length > 0 ? (
      filteredManagers.map((manager, index) => (
        <div
          key={manager.value}
          style={{ padding:"0px 10px" }}
          onClick={() => handleEmpClick(manager)}
        >
         <div className={`employee__top ${
    manager.value == selectedValue ? "selected-emp" : ""
  }`}  style={{ display:"flex", gap:"10px", cursor: 'pointer',alignItems: 'center' }} >
           <div className=" ">
            <GetImage
            redirect={false}
            key={manager.value}
              width="50px"
              height="50px"
              imgID={manager.value}
              empname={manager.label}
            />
          </div>
          <div className=" empolyeeName">
            {manager.label}
          </div>
          </div>
        </div>
      ))
    ) : (
      <div style={{color:"#ff6d00"}} className="text-center py-3 text-muted">No result found</div>
    )}
  </div>
</Modal.Body>
    </Modal>
  );
};

export default Empmodal;